import { z } from "zod";

export const createProductFormSchema = z.object({
  name: z.string().min(1, { message: "نام محصول الزامی است" }),
  price: z
    .number({ error: "قیمت الزامی است" })
    .min(1, { message: "قیمت باید عدد مثبت باشد" }),
  stock: z
    .number({ error: "موجودی الزامی است" })
    .int()
    .min(0, { message: "موجودی نمی‌تواند منفی باشد" }),
  sku: z.string().optional(),
  description: z.string().optional(),
  category_id: z.number().optional(),
  is_active: z.boolean(),
});

export type CreateProductFormValues = z.infer<typeof createProductFormSchema>;
